import { useCartStore } from '~/store/CartStore'
import { useUserStore } from '~/store/UserStore'

export default defineNuxtPlugin({
  name: 'fetch-cart',
  hooks: {
    // wait for rootData to be ready as we will use rootData.stripeAccount
    async 'rootData:ready'() {
      const { $pinia } = useNuxtApp()
      const cartStore = useCartStore($pinia)
      await cartStore.getCart()
      const userStore = useUserStore($pinia)
      // Clean up legacy token from localStorage (pre-SSR migration)
      const userStoreData = localStorage.getItem('user-store')
      if (userStoreData) {
        try {
          const parsed = JSON.parse(userStoreData)
          if (parsed.token) {
            delete parsed.token
            localStorage.setItem('user-store', JSON.stringify(parsed))
          }
        } catch {
          // ignore parse errors
        }
      }
      if (userStore.loggedIn) {
        const res = await userStore.getUser()
        if (res.data) {
          await userStore.setUser(res.data)
        } else {
          await userStore.setUser(null)
        }
      }
    },
  },
})
